<template>
  <div>
    <div v-if="clip_list.length > 0">
      <carousel
        :perPage="4"
        :perPageCustom="[[130, 1],[585, 2], [850, 3],[1190, 4]]"
        :navigationEnabled="true"
        :scrollPerPage="false"
        :paginationEnabled="false"
        navigationNextLabel="<i class='fa fa-chevron-right'></i>"
        navigationPrevLabel="<i class='fa fa-chevron-left'></i>"
      >
        <slide v-for="clip in clip_list" :clip="clip" :key="clip.id">
          <div
            class="col-md-4 col-sm-4 col-xs-6 no-padding no-margin featured-wraper add-clip"
            style="margin-bottom: 5px;"
          >
            <div class="popluar-clip four-grid">
              <div class="popluar-clips-container">
                <div class="popluar-clip-header">
                  <small>{{ $options.filters.getChartaters(clip.type_of_custom, 50, '...') }}</small>
                  <div class="clip-header-check" v-if="isAddedClip(clip.id) != true">
                    <div class="radio radio-primary">
                      <input
                        :id="clip.id"
                        :name="clip.id"
                        type="checkbox"
                        class="clip-checkbox"
                        @click="toggleSelect(clip.id)"
                        :checked="selectedClips.includes(clip.id)"
                      />
                      <label :for="clip.id" class="select_clip_radio"></label>
                    </div>
                  </div>
                  <h3>
                    <a href="#">{{ clip.title }}</a>
                  </h3>
                </div>
                <div class="popular-clip-author">
                  <a
                    :href="userUrl(clip.user.slug)"
                    v-if="clip.user && clip.user.user_type === '0'"
                  >by {{ clip.user.first_name }}</a>
                  <a
                    :href="userUrl(clip.user.slug)"
                    v-else-if="clip.user"
                  >by {{ clip.user.first_name + ' ' + clip.user.last_name }}</a>
                  <a href="#" v-else>by</a>
                </div>
                <div class="popluar-clip-content-wrapper">
                  <div v-if="clip.cliptype == 'image' & clip.image !== ''">
                    <div class="popluar-clip-content has-img">
                      <hr />
                      <div class="image">
                        <div class="popluar-clip-image">
                          <img
                            v-bind:src="clip.default_clip_image"
                            :alt="clip.title"
                            class="clip-image"
                            width="100%" height="100%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="clip.cliptype == 'audio'" v-html="clip.audio"></div>
                  <div v-else-if="clip.cliptype == 'video'" v-html="clip.video">
                    <!-- {{ clip.video }} -->
                  </div>
                  <div v-else>
                    <div class="popluar-clip-content has-text">
                      <hr />
                      <div v-html="$options.filters.getWords(clip.content, 81, '...')"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="clip-listing-detail popluar-clip-image-overlay popluar-clip-image-overlay-slider"
              >
                <div class="image-overlay-buttons">
                  <a
                    class="colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-blue"
                    id="clipViewbtn"
                    :href="route('user.clip.show',{ slug : clip.slug})"
                    target="_blank"
                  >View</a>
                  <br />
                  <div v-if="isAddedClip(clip.id) !== true">
                    <a
                      class="colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-primary-color"
                      v-if="selectedClips.includes(clip.id)"
                      @click.prevent="toggleSelect(clip.id)"
                    >DeSelect</a>
                    <a
                      class="colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-primary-color"
                      v-else
                      @click.prevent="toggleSelect(clip.id)"
                    >Select</a>
                  </div>
                </div>
              </div>
              <div class="popluar-clip-footer">
                <hr />
                <ul>
                  <li class="pull-left">
                    <a href="#" class="btn">
                      <i class="fa fa-search"></i>
                      <span>View {{ trans('clip.singular') }}</span>
                    </a>
                  </li>
                  <li class="pull-right">
                    <a href="#" class="list-action btn btn-dark">
                      <i class="fa fa-star"></i>
                      <span>Select {{ trans('clip.Singular') }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div v-else class="VueCarousel-error">
      <div v-if="errorMesg !== ''" class="clips-not-founded">{{ errorMesg }}</div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  props: ["clip", "existClips", "sectionKey"],
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      clip_list: [],
      selectedClips: [],
      existingClips: this.existClips,
      errorMesg: "",
      // isSelected: 0;
    };
  },
  filters: {
    getWords: function(value, return_words, last_word = "") {
      if (!value) return "";

      if (value.length > return_words) {
        return (
          value
            .split(/\s+/)
            .slice(0, return_words)
            .join(" ") + last_word
        );
      }
      return value;
    },
    coverImage(src) {
      var src_path = src.split("/");
      src_path.pop();
      src_path.push("conversions");
      src_path.push("cover.jpg");

      var result = src_path.join("/");
      return result;
    },
    getChartaters: function (value, return_characters, last_word = '') {
			if (!value) return ''
			value.replace('\n', '');
			if(value.length > return_characters){
				return value.substr(0,return_characters) + last_word;
			}
			return value;
		},
  },
  beforeCreate() {},
  created() {
    var vm = this; //declare this just BEFORE calling axios();
    this.checkSavedClips();
    console.log("created");
  },
  methods: {
    checkSavedClips(){
      var app = this;
      var available_clips = 0;
      this.myClip().then( (res) => {
        available_clips = Object.keys(res.data).length
        if(available_clips == 0) {
          app.bookmarkedClip().then( (res) => {
            available_clips = Object.keys(res.data).length
            if(available_clips == 0) {
              app.communityClip().then( (res) => {
                this.$emit('getValueToSelectTab', 'communityclip');
              });
            }else {
              this.$emit('getValueToSelectTab', 'bookmarkedclip');
            }
          });
        }else {
          this.$emit('getValueToSelectTab', 'myclip');
        }
      });
    },
    userUrl(slug) {
      return this.route('user.show', { slug: slug });
    },
    toggleSelect(id) {
      return this.selectedClips.includes(id)
        ? this.unSelect(id)
        : this.select(id);
    },
    select(id) {
      this.selectedClips.push(id);
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    unSelect(id) {
      //remove the id from the the list
      this.selectedClips = this.selectedClips.filter(function(clip) {
        return clip != id;
      });
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    unSelectAll() {
      //remove all the selected id from the the list
      this.selectedClips = [];
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    myClip() {
      var req = this.route('user.my-clips',{});
      var query = { params: { section_id: this.sectionKey } };

      return this.axiosRequest(req, query);
    },
    bookmarkedClip() {
      var req = this.route('user.bookmarked-clips',{});
      var query = { params: { section_id: this.sectionKey } };
      return this.axiosRequest(req, query);
    },
    communityClip() {
      var req = this.route('user.community-clips',{});
      var query = { params: { section_id: this.sectionKey } };

      return this.axiosRequest(req, query);
    },
    searchClip(word, tab_name) {
      axios
        .post("/search-clip", {
          word: word,
          section_id: this.sectionKey,
          tab_name: tab_name
        })
        .then(response => {
          if (response.data.length > 0) {
            this.clip_list = response.data;
          } else {
            this.clip_list = [];
            this.errorMesg =
              "Sorry, there are no " + this.trans('clip.multiple') + " that match your search.";
          }
        });
    },
    isAddedClip(id) {
      var vm = this;

      var is_exist = this.existingClips.filter(function(clip) {
        // Check the clip is exist in the current section or not
        if (clip.id === id && vm.sectionKey == clip.pivot.section_id) {
          return true;
        }
      });
      if (is_exist.length > 0) {
        return true;
      }
      return false;
    },
    axiosRequest(req, query) {
      var vm = this;
      return new Promise((resolve, reject) => {
        axios.get(req, query).then(response => {
          if (Object.keys(response.data).length > 0) {
            this.clip_list = response.data;
          }
           else {
            this.clip_list = [];
            this.errorMesg =
              "Sorry, there are no " + vm.trans('clip.multiple') + " found in this section";
          }
          resolve(response)
        });
      });
    }
  }
};
</script>

<style>
.VueCarousel-navigation-next,
.VueCarousel-navigation-prev {
  color: #fff !important;
  display: inline-table;
  font-weight: bolder;
  font-size: 22px;
  padding-bottom: 175px !important;
  padding-top: 175px !important;
  top: 55% !important;
  margin-top: -20px;
}
.VueCarousel-navigation-prev .fa,
.VueCarousel-navigation-next .fa {
  margin-top: 0px;
  margin-left: 0px;
}



.clip-checkbox {
  display: none;
}
.VueCarousel-slide {
  max-width: 280px;
}
</style>